/**
 * DashboardConfig model
 *
 * Flag key: "feature-program-dashboard-config"
 * Flag payload shape: { version: 'v1'|'v2', adminEnabled: boolean }
 *
 * Safety contract:
 *   - ALWAYS returns a DashboardConfig instance (never null/throws).
 *   - Unknown/missing version → 'v1' (safe degradation).
 *   - Non-boolean adminEnabled → false.
 *   - Unrecognised version also forces adminEnabled → false (belt-and-suspenders).
 */

const VALID_VERSIONS = ["v1", "v2"];

class DashboardConfig {
  constructor({ version = "v1", adminEnabled = false } = {}) {
    this.version = version;
    this.adminEnabled = adminEnabled;
  }

  static fromFlagData(data) {
    try {
      if (data == null || typeof data !== "object" || Array.isArray(data)) {
        return new DashboardConfig();
      }

      const isKnownVersion = VALID_VERSIONS.includes(data.version);

      if (!isKnownVersion) {
        // Unrecognised version — entire payload untrusted, safe defaults
        return new DashboardConfig();
      }

      const adminEnabled = data.adminEnabled === true;

      return new DashboardConfig({ version: data.version, adminEnabled });
    } catch (_) {
      return new DashboardConfig();
    }
  }
}

export default DashboardConfig;
